import Vue from 'vue'
import App from './App.vue'
import Axios from 'axios'
Vue.config.productionTip = false

Vue.prototype.$axios = Axios
Axios.defaults.baseURL = '/booking2021'
// Axios.defaults.baseURL = 'https://huodong.zsnews.cn/booking2021'
Axios.defaults.timeout = 10000
new Vue({
  render: h => h(App),
}).$mount('#app')

